import { useState } from "react";
import { createPortal } from "react-dom";
import { QRCodeSVG } from "qrcode.react";

/** A scannable QR for the player join deep link (PIN pre-filled on the join screen).
 *  Click it to pop a full-screen enlarged copy — handy when the on-screen QR is
 *  small (in-quiz header, scoreboard) and bakers are sat at the back of the room. */
export default function JoinQR({
  pin,
  size,
  caption,
}: {
  pin: string;
  size: number;
  caption?: string;
}) {
  const [open, setOpen] = useState(false);
  const url = `${location.origin}/play/${pin}`;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Enlarge the join QR code"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
          border: "none",
          background: "none",
          padding: 0,
          cursor: "pointer",
          font: "inherit",
        }}
      >
        <div style={{ background: "#fff", padding: 12, borderRadius: 16, boxShadow: "var(--sh)", lineHeight: 0 }}>
          <QRCodeSVG value={url} size={size} level="M" />
        </div>
        <span className="bk-eyebrow" style={{ color: "var(--ink-soft)" }}>
          {caption ?? "CLICK TO ENLARGE"}
        </span>
      </button>

      {open && createPortal(
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "grid",
            placeItems: "center",
            background: "rgba(40,20,8,.66)",
            backdropFilter: "blur(3px)",
            animation: "bk-fade-in .18s ease both",
            cursor: "zoom-out",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 22,
              background: "#fff",
              padding: "40px 44px 34px",
              borderRadius: 28,
              boxShadow: "var(--sh-lg)",
              cursor: "auto",
            }}
          >
            <QRCodeSVG value={url} size={Math.round(Math.min(560, window.innerHeight * 0.6))} level="M" />
            <div style={{ textAlign: "center" }}>
              <div className="bk-eyebrow" style={{ color: "var(--ink-soft)", marginBottom: 6 }}>SCAN TO JOIN — OR ENTER THE PIN</div>
              <div className="mono" style={{ fontSize: 56, fontWeight: 700, letterSpacing: ".1em", color: "var(--red)", lineHeight: 1 }}>
                {pin}
              </div>
            </div>
            <button className="bk-btn bk-btn--ghost" onClick={() => setOpen(false)}>Close</button>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
